import type { RootState } from 'store';
import clipDownloadSlice, { AssetPayload, CLIP_DOWNLOAD_STATE } from './slice';

export function getClipConversion(state: RootState, args: AssetPayload) {
    const { id: assetId, provider } = args;

    return state.video?.[clipDownloadSlice.name]?.[`${provider}:${assetId}`]?.clip;
}

export function getDownloadableClips(state: RootState, args: AssetPayload) {
    const { id: assetId, provider } = args;

    return state.video?.[clipDownloadSlice.name]?.[`${provider}:${assetId}`]?.clip?.clips;
}

export function getClipConversionState(state: RootState, args: AssetPayload) {
    const { id: assetId, provider } = args;

    return state.video?.[clipDownloadSlice.name]?.[`${provider}:${assetId}`]?.clip?.state || CLIP_DOWNLOAD_STATE.DONE;
}

export function getClipConversionProgress(state: RootState, args: AssetPayload) {
    const { id: assetId, provider } = args;

    return state.video?.[clipDownloadSlice.name]?.[`${provider}:${assetId}`]?.clip?.progress;
}

export function getClipConversionPendingState(state: RootState, args: AssetPayload) {
    const { id: assetId, provider } = args;

    return state.video?.[clipDownloadSlice.name]?.[`${provider}:${assetId}`]?.clip?.clipDownloadPending;
}

export function isClipConversionInProgress(state: RootState, args: AssetPayload & { id: number }) {
    const { id: assetId, provider } = args;

    return state.video?.[clipDownloadSlice.name]?.[`${provider}:${assetId}`]?.clip?.state === 'convert';
}
